import { useId } from 'react'

import { ButtonSize } from './Buttons/types'

export default function Spinner({
  backgroundColor,
  className,
  color = 'white',
  size = 'small',
}: {
  backgroundColor?: string
  className?: string
  color?: 'white' | 'purple' | 'black'
  size?: ButtonSize | number
}): React.ReactElement {
  const spinnerSize = getSpinnerSize(size)
  const spinnerColor = getSpinnerColor(color)
  const clipPathId = useId()

  return (
    <svg
      className={`animate-spin ${className}`}
      fill="none"
      height={spinnerSize}
      role="alert"
      viewBox="0 0 130 130"
      width={spinnerSize}
      xmlns="http://www.w3.org/2000/svg"
    >
      {backgroundColor && (
        <path
          d="M0 65C0 29.1015 29.1015 0 65 0C100.899 0 130 29.1015 130 65C130 100.899 100.899 130 65 130C29.1015 130 0 100.899 0 65ZM111 65C111 39.5946 90.4054 18.9995 65 18.9995C39.5946 18.9995 18.9995 39.5946 18.9995 65C18.9995 90.4054 39.5946 111 65 111C90.4054 111 111 90.4054 111 65Z"
          fill={backgroundColor}
        />
      )}
      <clipPath id={clipPathId}>
        <path d="M0 65C0 29.1015 29.1015 0 65 0C100.899 0 130 29.1015 130 65C130 100.899 100.899 130 65 130C29.1015 130 0 100.899 0 65ZM111 65C111 39.5946 90.4054 18.9995 65 18.9995C39.5946 18.9995 18.9995 39.5946 18.9995 65C18.9995 90.4054 39.5946 111 65 111C90.4054 111 111 90.4054 111 65Z" />
      </clipPath>
      <path
        d="M65 0H65.5C70.7467 0 75 4.2533 75 9.5V9.5C75 14.7467 70.7467 19 65.5 19H65V0Z"
        fill={`rgb(${spinnerColor})`}
      />
      <foreignObject clipPath={`url(#${clipPathId})`} height="130" width="130">
        <div
          style={{
            height: '100%',
            width: '100%',
            background: `conic-gradient(transparent, rgba(${spinnerColor}, .5), rgb(${spinnerColor}))`,
          }}
        />
      </foreignObject>
    </svg>
  )
}

function getSpinnerColor(color: 'white' | 'purple' | 'black'): string {
  switch (color) {
    case 'purple':
      return '125, 56, 214'

    case 'black':
      return '0, 0, 0'

    default:
      return '255, 255, 255'
  }
}

function getSpinnerSize(size: ButtonSize | number): number {
  switch (size) {
    case 'huge':
      return 32

    case 'large':
      return 28

    case 'medium':
      return 24

    case 'small':
      return 22

    case 'x-small':
      return 22

    default:
      return size as number
  }
}
